// 1. Find li previous ...
export const getPreviousLi = ({ li }) => {
  if (!li || li.tagName.toLowerCase() !== "li") return null;

  let prev = li.previousSibling;

  while (prev) {
    if (
      prev.nodeType === Node.ELEMENT_NODE &&
      prev.tagName.toLowerCase() === "li"
    ) {
      return prev;
    }
    prev = prev.previousSibling;
  }

  return null;
};

//2. Check if li is in a nested list (direct parent is ul/ol inside another ul/ol)
export const isNestedListLi = ({ li }) => {
  if (!li || li.tagName.toLowerCase() !== "li") return false;

  const parentList = li.parentElement; // ul or ol
  if (!parentList) return false;

  const parentTag = parentList.tagName.toLowerCase();
  if (parentTag !== "ul" && parentTag !== "ol") return false;

  const grandParent = parentList.parentElement; // should be ul or ol (not li)
  if (!grandParent) return false;

  const gpTag = grandParent.tagName.toLowerCase();

  return gpTag === "ul" || gpTag === "ol";
};

// 3. Unwrap nested list - move li up one level
export const unwrapNestedList = ({ li }) => {
  if (!li || li.tagName.toLowerCase() !== "li") return null;

  const parentList = li.parentElement; // nested ul or ol
  if (!parentList) return null;

  const parentTag = parentList.tagName.toLowerCase();
  if (parentTag !== "ul" && parentTag !== "ol") return null;

  const grandParent = parentList.parentElement; // outer ul or ol
  if (!grandParent) return null;

  const gpTag = grandParent.tagName.toLowerCase();
  if (gpTag !== "ul" && gpTag !== "ol") return null;

  // Move li from nested list to outer list (after nested list)
  if (parentList.nextSibling) {
    grandParent.insertBefore(li, parentList.nextSibling);
  } else {
    grandParent.appendChild(li);
  }

  // If nested list is now empty, remove it
  if (parentList.children.length === 0) {
    parentList.remove();
  }

  return li;
};
